// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"390":"11e0b460","551":"a3a25b8c","773":"7aaa7e47"}[chunkId] + ".chunk.css";
};